import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { AccordionClass } from ".";

interface HistoryAccordionProps {
  historyCalculated: string | null;
  tirageHistoryCalculated: string | null;
  t: (key: string) => string;
}

export function HistoryAccordion({
  historyCalculated,
  tirageHistoryCalculated,
  t,
}: HistoryAccordionProps) {
  if (!historyCalculated && !tirageHistoryCalculated) return null;

  return (
    <AccordionItem value="history">
      <AccordionTrigger>{t("singleArtworkSubtitleHistory")}</AccordionTrigger>
      <AccordionContent>
        {historyCalculated && (
          <div
            dangerouslySetInnerHTML={{
              __html: historyCalculated,
            }}
            className={AccordionClass}
          />
        )}
        {tirageHistoryCalculated && (
          <>
            {historyCalculated && <div className="mt-4" />}
            <div
              dangerouslySetInnerHTML={{
                __html: tirageHistoryCalculated,
              }}
              className={AccordionClass}
            />
          </>
        )}
      </AccordionContent>
    </AccordionItem>
  );
}
